import React, { useState, useEffect } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/service.css";
import c2 from "../images/c2.jpeg";
import { constructServices } from "../globals/data";

const Service = () => {

  const [services, setServices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);

  const handleShow = (service) => {
    setSelectedService(service);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
  };

  const fetchServices = async () => {
    setServices(constructServices);
  };

  useEffect(() => {
    fetchServices();
    window.scrollTo(0, 0);
  }, []);

  const truncateText = (text, limit = 250) => {
    if (text.length > limit) {
      return text.substring(0, limit) + " ...";
    }
    return text;
  };

  return (
    <div className="service-main">
      <div className="service-background">
        <h3>Services</h3>
        <div className="after-line-service"></div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12 services-heading">
            <h2>Our Services</h2>
            <p>We provide a wide range of services to cater to your needs</p>
          </div>
        </div>
      </div>
      <div className="services-row">
        <div className="container">
          <div className="row ">
            <div className="col-md-8 services-description">
              <h2>Facilitating Peoples</h2>
              <p>
                We provide comprehensive support for construction sites by offering reliable tools,
                equipment, and expert services to streamline operations and enhance productivity.
                From delivering high-quality materials to ensuring site safety and efficiency, we focus on meeting
                the unique needs of every project. Our team is committed to facilitating seamless workflows, minimizing
                downtime, and helping clients achieve their construction goals with ease and confidence.
              </p>
              <div className="row">
                <div className="col-md-6 service-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="20px"
                    width="20px"
                  >
                    <path
                      fill="#fd7000"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                    />
                  </svg>
                  <h6>Residential/Commercial Building</h6>
                </div>
                <div className="col-md-6 service-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="20px"
                    width="20px"
                  >
                    <path
                      fill="#fd7000"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                    />
                  </svg>
                  <h6>Interior Designs</h6>
                </div>
                <div className="col-md-6 service-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="20px"
                    width="20px"
                  >
                    <path
                      fill="#fd7000"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                    />
                  </svg>
                  <h6>Electrical</h6>
                </div>
                <div className="col-md-6 service-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="20px"
                    width="20px"
                  >
                    <path
                      fill="#fd7000"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                    />
                  </svg>
                  <h6>Government Sector</h6>
                </div>
                <div className="col-md-6 service-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="20px"
                    width="20px"
                  >
                    <path
                      fill="#fd7000"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                    />
                  </svg>
                  <h6>Metal</h6>
                </div>
                <div className="col-md-6 service-logo">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    height="20px"
                    width="20px"
                  >
                    <path
                      fill="#fd7000"
                      d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                    />
                  </svg>
                  <h6>Concrete Works</h6>
                </div>
              </div>
            </div>
            <div className="col-md-4 services-main-image">
              <img src={c2} alt="Services Main" />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4 card-width">
              <Card>
                <Card.Img
                  variant="top"
                  src={service.image}
                  alt={service.title}
                  style={{ height: "150px", objectFit: "cover" }}
                />
                <Card.Body>
                  <Card.Title>{service.title}</Card.Title>
                  <Card.Text>{truncateText(service.description)}</Card.Text>
                  <Button
                    variant="primary"
                    onClick={() => handleShow(service)}
                    className="button-modal"
                  >
                    Read More
                  </Button>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedService?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedService?.image && (
            <img
              src={selectedService.image}
              alt={selectedService.title}
              style={{
                width: "100%",
                height: "auto",
                marginBottom: "15px",
                borderRadius: "5px",
              }}
            />
          )}
          <h5>{selectedService?.process}</h5>
          <p>{selectedService?.description}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="button-close"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Service;
